import React from 'react'
import { graphql, usePaginationFragment } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { EventCard } from '@newComponents/Event/EventCard'
import { Grid } from '@newComponents/Grid'

import { PresentationEvents_presentation$key } from './__generated__/PresentationEvents_presentation.graphql'

type PresentationEventsProps = {
  presentation: PresentationEvents_presentation$key
}

const PresentationEvents = (props: PresentationEventsProps) => {
  const { data } = usePaginationFragment(
    graphql`
      fragment PresentationEvents_presentation on Presentation
      @refetchable(queryName: "PresentationEventsPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 4 }
        cursor: { type: "Cursor" }
      ) {
        events(first: $count, after: $cursor)
          @connection(key: "PresentationEvents_presentation_events") {
          edges {
            node {
              id
              ...EventCardNew_event
            }

            cursor
          }
        }
      }
    `,
    props.presentation
  )

  if (data.events.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$5'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$grey8'>Presented at these Events</Strong>
        <Separator borderColor='$grey4' />
      </XStack>

      <YStack gap='$4'>
        {data.events.edges.length === 1 ? (
          <EventCard event={data.events.edges[0].node} flex={1} />
        ) : (
          <Grid gap='$4'>
            {data.events.edges.map((edge) => (
              <Grid.Column key={edge.cursor}>
                <EventCard event={edge.node} flex={1} />
              </Grid.Column>
            ))}
          </Grid>
        )}
      </YStack>
    </YStack>
  )
}

export default PresentationEvents
